import serviceClient from '../../service-client/service-client';
import pollAsyncJob from '../../../utils/poll-async-job';
import site from '../../site';

const POLLING_INTERVAL = 3000;

const initiateLanguageCreation = async ({ locale, translateWithAi, onPoll }) => {
  const client = serviceClient.get();
  const siteId = site.accessors.getSiteId();

  const response = await client.initiateLanguageCreation(siteId, {
    locale,
    translateWithAi,
  });
  const {
    data: { id: jobId },
  } = response;

  return pollAsyncJob({ jobId, interval: POLLING_INTERVAL, onPoll });
};

export default initiateLanguageCreation;
